import React from 'react';

export default function ChevronRight({className}) {
	return (
        <svg className={className ? className : ''} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 11" preserveAspectRatio="xMidYMid meet"><path d="M7 5.5L1.4 0 0 1.4l4.1 4.1L0 9.6 1.4 11 7 5.5z"/></svg>
	);
}
